import PropTypes from 'prop-types';
import React from 'react';
import UserManagementList from '../components/UserManagementList';
import {connectToStores} from 'fluxible-addons-react';
import Actions from '../../../constants/Actions';
import {LinkShape} from '../../../utils/react/Shapes';
import {intlShape} from 'react-intl';
import cx from 'classnames';
import {userSearchChanged, resetFormErrors, setShowInactiveUsers} from '../actions/UserManagementActionCreator';
import DebounceInput from 'react-debounce-input';
import FontAwesome from 'react-fontawesome';
import {Link} from 'react-router';
import ProtectedComponent from '../../../components/ProtectedComponent';
import Unauthorized from '../../../pages/Unauthorized';
import Roles from '../../../constants/Roles';
import classnames from 'classnames';
import fileDownload from 'js-file-download';

function alternative() {
  return <Unauthorized />;
}

class DownloadCSV  extends React.PureComponent {
  static propTypes = {
    fileName: PropTypes.string.isRequired,
    users: PropTypes.arrayOf(LinkShape),
    showInactiveUsers: PropTypes.bool,
    className: PropTypes.string
  };

  render() {
    const classes = classnames('btn', 'btn-outline-secondary', this.props.className);
    return (
      <button className={classes} onClick={this.onClick} title="Download CSV file">
        <FontAwesome name="download" />
      </button>
    );
  }

  onClick = () => {
    const csv = this.props.users.sort((a,b) => a.name.localeCompare(b.name)).map((element) => {
      return `${this.props.showInactiveUsers && element.disabled ? '*': ''}${element.name}, ${element.tags.join(' | ')}`;
    });
    fileDownload(csv.join('\n'), `${this.props.fileName}.csv`);
  }
}

@connectToStores(['UserManagementStore'], (context) => {
  const UserManagementStore = context.getStore('UserManagementStore');
  const users = UserManagementStore.getManagedUsers();
  const showInactiveUsers = UserManagementStore.getShowInactiveUsers();

  const links = users
    .filter(oneUser => oneUser.get('active') || showInactiveUsers)
    .map(oneUser => {
      const viewUrl = `/user-management/view/${oneUser.get('id')}`;
      return {
        id: oneUser.get('id'),
        name: `${oneUser.get('firstName')} ${oneUser.get('lastName')}`,
        description: `${oneUser.get('emailAddress')}`,
        url: viewUrl,
        tags: [`${oneUser.getIn(['settings', 'title'])}`],
        disabled: !oneUser.get('active')
      };
    })
    .toJS();

  return {
    links: links,
    showInactiveUsers: showInactiveUsers
  };
})
class UserManagementMain extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    links: PropTypes.arrayOf(LinkShape).isRequired,
    search: PropTypes.string,
    showInactiveUsers: PropTypes.bool.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  static async loadAction(context) {
    console.log('Loading user management main');
    const result = await context.service.read('userManagement', {listAll: true});
    console.log('Obtained managed users: ', result.data);
    context.dispatch(Actions.USER_MANAGEMENT_LIST_MANAGED_USERS, result.data);

    const roles = await context.service.read('userManagement', {listUserRoles: true});
    console.log('Found these roles', roles);
    context.dispatch(Actions.USER_MANAGEMENT_LIST_USER_ROLES, roles.data);

    const branchHierarchyAndTerms = await context.service.read('userManagement', {findBranchHierarchyAndTerms: true});
    console.log('Found branch hierarchy and terms.');
    context.dispatch(Actions.USER_MANAGEMENT_SET_BRANCH_HIERARCHY_AND_TERMS, branchHierarchyAndTerms.data);

  }

  constructor(props) {
    super(props);
  }

  render() {
    const userListBoxClasses = {
      'flex-element': true,
      'flex-container': true,
      'flex-vertical': true,
      'card-search': true
    };

    const userDetailBoxClasess = {
      'flex-element': true,
      'flex-container': true,
      'flex-vertical': true,
      'dashboard-content': true,
      'scroll-y': true
    };

    if (this.props.children) {
      userListBoxClasses['flex-off'] = true;
    } else {
      userDetailBoxClasess['flex-off'] = true;
    }

    const {links, search, showInactiveUsers} = this.props;

    const searchChanged = (event) => {
      this.context.executeAction(userSearchChanged, event.target.value);
    };

    const linkClicked = () => {
      this.context.executeAction(resetFormErrors);
    };

    const toggleShowInactiveUsers = (event) => {
      console.log('toggleShowInactiveUsers');
      event.preventDefault();
      this.context.executeAction(setShowInactiveUsers, event.target.checked);
    };

    return (
      <ProtectedComponent role={Roles.USER_MANAGER} alternateComponent={alternative}>
        <main className="content form-container flex-container flex-element flex-vertical dashboard">
          <h1 className="dashboard-header">
            User Management
          </h1>
          <div className="flex-container flex-element dashboard-content">
            <article className={ cx(userListBoxClasses) }>
              <div className="text-center">
                <div className="search-user text-center">
                  <DebounceInput debounceTimeout={ 250 }
                                 type="text"
                                 placeholder="Search..."
                                 value={ search }
                                 className="form-control"
                                 style={{width: '12rem', display: 'inline-block', marginRight: '0.3rem'}}
                                 onChange={ searchChanged }/>
                  <DownloadCSV fileName="users" users={links} showInactiveUsers={showInactiveUsers} />
                </div>
                <div className="toggle-inactive-user text-center">
                  <input
                    type="checkbox"
                    className="form-control"
                    id="toggle-inactive-user"
                    checked={this.props.showInactiveUsers}
                    onChange={toggleShowInactiveUsers}/>
                  <label htmlFor="toggle-inactive-user">Show inactive users</label>
                </div>
              </div>
              <div className="scroll-y flex-container flex-wrap flex-element">
                <UserManagementList links={ links } clickHandler={linkClicked}/>
                <div className="user-management-add-new flex-container flex-justify-center flex-align-center flex-align-self-end link-group card-deck flex-element">
                  <Link key="user-new" to="/user-management/new" className="card card-link card-link-row ">
                    New User&nbsp;<FontAwesome name="plus-circle" />
                  </Link>
                  <hr/>
                </div>
              </div>
            </article>
            <article className={ cx(userDetailBoxClasess) }>
              {this.props.children}
            </article>
          </div>
        </main>
      </ProtectedComponent>
    );
  }

}

export default UserManagementMain;



// WEBPACK FOOTER //
// ./src/apps/UserManagement/components/UserManagementMain.js